import { createFileRoute, redirect } from '@tanstack/react-router';

import { DelegateWorkersPage } from '@/features/delegate/components/DelegateWorkersPage';
import { useAuthStore } from '@/shared/stores/authStore';

export const Route = createFileRoute('/user/')({
  beforeLoad: () => {
    // A delegate with a freshly generated password must change it first.
    if (useAuthStore.getState().user?.mustChangePassword) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router contract: beforeLoad throws a redirect object.
      throw redirect({ to: '/user/change-password' });
    }
  },
  component: DelegateWorkersPage,
});
